import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {SOConsolidationLinkModel} from "../../../../../../models/aggregates/so-consolidation/index";
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from "../../shared";
import {Observable} from 'rxjs';

@Injectable({
  providedIn: "root",
})
export class SOConsolidationLinkService extends BaseApiTemplateService<SOConsolidationLinkModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-hdr-slsinv-links/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "sales-order-to-sales-invoice-consolidation/run-hdr-slsinv-links/backoffice-ep";
    this.httpClient = http;
  }
}
